var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB151(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.59,
    height: 79.634,
    viewBox: "0 0 82.59 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_619_49",
    "data-name": "Component 619 \\u2013 49",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29770",
    "data-name": "Group 29770"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 19.246,
    transform: "translate(3.354)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 19.246,
    transform: "translate(29.986)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 19.246,
    transform: "translate(56.618)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 73.648,
    transform: "translate(0 39.979)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M4269.617,2606.9v12.1a7.407,7.407,0,0,0,14.814,0v-12.1",
    transform: "translate(-4264.048 -2566.867)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M4336.78,2606.9v12.1a7.407,7.407,0,0,0,14.814,0v-12.1",
    transform: "translate(-4304.579 -2566.867)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M4403.944,2606.9v12.1a7.408,7.408,0,0,0,7.408,7.407h0a7.407,7.407,0,0,0,7.407-7.407v-12.1",
    transform: "translate(-4345.111 -2566.867)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 25.869,
    transform: "translate(73.648 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y2: 25.869,
    transform: "translate(58.833 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y1: 25.869,
    transform: "translate(46.952 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y2: 25.869,
    transform: "translate(32.138 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 25.869,
    transform: "translate(20.257 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 25.869,
    transform: "translate(5.442 5.31)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 16.014,
    transform: "translate(15.426 9.582)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M4291.466,2622.055v5.165a2.278,2.278,0,0,1-2.342,2.342h0",
    transform: "translate(-4275.82 -2576.011)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 16.014,
    transform: "translate(41.73 9.582)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M4357.8,2622.055v5.165a2.278,2.278,0,0,1-2.342,2.342h0",
    transform: "translate(-4315.853 -2576.011)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y2: 16.014,
    transform: "translate(68.035 9.582)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M4424.14,2622.055v5.165a2.278,2.278,0,0,1-2.342,2.342h0",
    transform: "translate(-4355.885 -2576.011)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M4334.661,2630.161h-79.09V2618.72h79.09v-33.094h-79.09",
    transform: "translate(-4255.571 -2554.027)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB151);
export default __webpack_public_path__ + "static/media/hla-b-15-1.e22349783625ff28293239ebbf862abd.svg";
export { ForwardRef as ReactComponent };